"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventAppointmentStruct = void 0;
const superstruct_1 = require("superstruct");
const types_1 = require("../types");
const replaceTimestamps_1 = require("./replaceTimestamps");
exports.EventAppointmentStruct = (0, superstruct_1.type)((0, replaceTimestamps_1.replaceTimestamps)(types_1.AppointmentStruct.schema));
//# sourceMappingURL=EventAppointment.js.map